<template>
  <video-quick-tour
    :height="videoHeight"
    video-name="Intro1_StoryMode"
  >
    <h4 class="my-3 my-xl-0 font-outfit-medium">
      {{ $t('welcomeToBusinessGuide') }}
    </h4>
    <div v-html="$t('businessGuideQuickTourText')" />
  </video-quick-tour>
</template>

<script>
import VideoQuickTour from '@/components/_v2/VideoQuickTour'

export default {
  name: 'BusinessGuideQuickTour',

  components: {
    VideoQuickTour
  },

  props: {
    videoHeight: {
      type: String,
      default: '320'
    }
  }
}
</script>
